import { render, staticRenderFns } from "./GroupSyncHistory.vue?vue&type=template&id=b362dbca"
import script from "./GroupSyncHistory.vue?vue&type=script&lang=ts"
export * from "./GroupSyncHistory.vue?vue&type=script&lang=ts"
import style0 from "./GroupSyncHistory.vue?vue&type=style&index=0&id=b362dbca&prod&lang=css"
import style1 from "./GroupSyncHistory.vue?vue&type=style&index=1&id=b362dbca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports